module.exports = __webpack_public_path__ + "static/intro-4707b97bc07e5b878c519cec12660801.svg";